export const SecurityTypes = {
    SET_CODE_CHALLENGE: 'SET_CODE_CHALLENGE',
    FETCH_VERIFY_TOKEN: 'FETCH_VERIFY_TOKEN',
    TOKEN_REJECTED: 'TOKEN_REJECTED',
    TOKEN_VERIFIED: 'TOKEN_VERIFIED'
}